<template>
  <div>
    <ContentWrap title="直播举报">
      <el-form :inline="true" class="mb8">
        <el-form-item label="直播间">
          <LiveRoomIdSelect v-model="queryParams.liveId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" clearable placeholder="全部" class="!w-140px">
            <el-option label="待处理" :value="0" />
            <el-option label="已处理" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery"> <Icon icon="ep:search" />查询 </el-button>
          <el-button @click="resetQuery"> <Icon icon="ep:refresh" />重置 </el-button>
        </el-form-item>
      </el-form>
    </ContentWrap>

    <ContentWrap>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="编号" prop="id" width="80" />
        <el-table-column label="直播间 ID" prop="liveId" width="100" />
        <el-table-column label="举报人" prop="reporterUserId" width="100" />
        <el-table-column label="类型" prop="reportType" width="120" />
        <el-table-column label="标题" prop="title" min-width="140" show-overflow-tooltip />
        <el-table-column label="内容" prop="content" min-width="180" show-overflow-tooltip />
        <el-table-column label="联系方式" prop="contact" width="130" show-overflow-tooltip />
        <el-table-column label="证据" width="90">
          <template #default="scope">
            <el-button
              v-if="parseMedia(scope.row.picUrls).length"
              link
              type="primary"
              @click="openDetail(scope.row)"
              >{{ parseMedia(scope.row.picUrls).length }} 个</el-button
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="90">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'">{{
              scope.row.status === 1 ? '已处理' : '待处理'
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="处理结果"
          prop="handleResult"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="160" fixed="right">
          <template #default="scope">
            <el-button link type="primary" @click="openDetail(scope.row)">详情</el-button>
            <el-button
              v-if="scope.row.status !== 1"
              link
              type="primary"
              @click="openHandle(scope.row)"
              v-hasPermi="['live:report:update']"
              >处理</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        @pagination="getList"
      />
    </ContentWrap>

    <el-dialog title="举报详情" v-model="detailVisible" width="720px" append-to-body>
      <el-descriptions :column="1" border>
        <el-descriptions-item label="直播间 ID">{{ currentRow?.liveId }}</el-descriptions-item>
        <el-descriptions-item label="举报人">{{ currentRow?.reporterUserId }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ currentRow?.reportType }}</el-descriptions-item>
        <el-descriptions-item label="标题">{{ currentRow?.title }}</el-descriptions-item>
        <el-descriptions-item label="内容">{{ currentRow?.content || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{
          currentRow?.contact || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          {{ currentRow?.status === 1 ? '已处理' : '待处理' }}
        </el-descriptions-item>
        <el-descriptions-item label="处理结果">{{
          currentRow?.handleResult || '--'
        }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="detailMedia.length" class="media-block">
        <div class="media-title">用户上传证据</div>
        <div class="media-grid">
          <template v-for="(url, idx) in detailMedia" :key="url + idx">
            <el-image
              v-if="isImage(url)"
              :src="url"
              :preview-src-list="detailImages"
              fit="cover"
              class="media-thumb"
            />
            <a v-else :href="url" target="_blank" rel="noopener" class="media-video">
              视频 {{ idx + 1 }}
            </a>
          </template>
        </div>
      </div>
      <div v-else class="media-empty">暂无上传证据</div>
      <template #footer>
        <el-button @click="detailVisible = false">关 闭</el-button>
        <el-button
          v-if="currentRow?.status !== 1"
          type="primary"
          v-hasPermi="['live:report:update']"
          @click="openHandleFromDetail"
          >去处理</el-button
        >
      </template>
    </el-dialog>

    <el-dialog title="处理举报" v-model="dialogVisible" width="500px" append-to-body>
      <el-form
        ref="formRef"
        :model="form"
        :rules="withLiveInputLimits(rules, liveInputLimits)"
        label-width="100px"
      >
        <el-form-item label="举报标题">
          <el-input :model-value="currentRow?.title" disabled />
        </el-form-item>
        <el-form-item label="举报内容">
          <el-input :model-value="currentRow?.content" type="textarea" :rows="3" disabled />
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input :model-value="currentRow?.contact || '--'" disabled />
        </el-form-item>
        <el-form-item label="处理状态">
          <el-tag type="success">处理后标记为已处理</el-tag>
        </el-form-item>
        <el-form-item label="处理备注" prop="result">
          <el-input
            show-word-limit
            :maxlength="500"
            v-model="form.result"
            type="textarea"
            :rows="3"
            placeholder="请输入处理结果/备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { withLiveInputLimits } from '@/utils/liveInputLimits'
const liveInputLimits = { result: 500 }

import { dateFormatter } from '@/utils/formatTime'
import { ref, reactive, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { page, handle } from '@/api/live/report'
import LiveRoomIdSelect from '@/views/live/components/LiveRoomIdSelect.vue'

const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const dialogVisible = ref(false)
const detailVisible = ref(false)
const formRef = ref<any>(null)
const currentRow = ref<any>(null)

const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  liveId: undefined as number | undefined,
  status: undefined as number | undefined
})

const form = reactive({
  result: ''
})

const rules = {
  result: [{ required: true, message: '处理备注不能为空', trigger: 'blur' }]
}

const parseMedia = (raw?: string) =>
  String(raw || '')
    .split(/[,，\n]/)
    .map((s) => s.trim())
    .filter(Boolean)

const isVideo = (url: string) => /\.(mp4|mov|m4v|webm|avi)(\?|$)/i.test(url)
const isImage = (url: string) => !isVideo(url)

const detailMedia = computed(() => parseMedia(currentRow.value?.picUrls))
const detailImages = computed(() => detailMedia.value.filter((u) => isImage(u)))

const getList = async () => {
  loading.value = true
  try {
    const params: any = {
      pageNo: queryParams.pageNo,
      pageSize: queryParams.pageSize,
      liveId: queryParams.liveId
    }
    if (queryParams.status !== undefined && queryParams.status !== null) {
      params.status = queryParams.status
    }
    const data: any = await page(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.liveId = undefined
  queryParams.status = undefined
  queryParams.pageNo = 1
  getList()
}

const openDetail = (row: any) => {
  currentRow.value = row
  detailVisible.value = true
}

const openHandle = (row: any) => {
  currentRow.value = row
  form.result = ''
  dialogVisible.value = true
}

const openHandleFromDetail = () => {
  detailVisible.value = false
  openHandle(currentRow.value)
}

const submitHandle = async () => {
  await formRef.value?.validate()
  await handle(currentRow.value.id, form.result)
  ElMessage.success('处理成功')
  dialogVisible.value = false
  getList()
}

onMounted(() => {
  getList()
})
</script>

<style scoped>
.media-block {
  margin-top: 16px;
}
.media-title {
  margin-bottom: 10px;
  font-weight: 600;
}
.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.media-thumb {
  width: 96px;
  height: 96px;
  border-radius: 6px;
  overflow: hidden;
}
.media-video {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  color: #fff;
  background: #303133;
  border-radius: 6px;
  text-decoration: none;
  font-size: 13px;
}
.media-empty {
  margin-top: 16px;
  color: #909399;
  font-size: 13px;
}
</style>
